import api from "shared/api";
import { BaseApiService } from "shared/api";
import { withToast } from "shared/utils";

class FilesService extends BaseApiService {
  _toFormData(files) {
    const formData = new FormData();
    files.forEach((fileData) => {
      formData.append(fileData.uid, fileData.file);
    });
    return formData;
  }
  async saveFiles(files, options) {
    return await withToast(() =>
      api.post(
        this.ENDPOINTS.attachments.store,
        this._toFormData(files),
        options
      )
    ).then((response) => response.data.data);
  }
  async saveFilesWithOCR(files, options, setFilesWithErrors) {
    return await withToast(() =>
      api.post(
        this.ENDPOINTS.attachments.ocr.store,
        this._toFormData(files),
        options
      )
    ).then(({ data }) => {
      if (data.negative_results.data.length > 0)
        setFilesWithErrors(data.negative_results.data);
      else setFilesWithErrors([]);
      return data.positive_results.data;
    });
  }
}

export default new FilesService();
